import { EnvironmentProviders, importProvidersFrom } from '@angular/core'
import { IconDefinition } from '@ant-design/icons-angular'
import {
    MenuFoldOutline,
    MenuUnfoldOutline,
    FormOutline,
    DashboardOutline,
    SettingOutline,
    AppleOutline,
    AndroidOutline,
} from '@ant-design/icons-angular/icons'
import { NzIconModule } from 'ng-zorro-antd/icon'

const icons: IconDefinition[] = [
    MenuFoldOutline,
    MenuUnfoldOutline,
    DashboardOutline,
    FormOutline,
    SettingOutline,
    AppleOutline,
    AndroidOutline,
]

export function provideNzIcons(): EnvironmentProviders {
    return importProvidersFrom(NzIconModule.forRoot(icons))
}
